import React from 'react';
import { Portal } from '../../../shared/components/Portal';
import { usePlot } from '../contexts/plot.context';
import { Grid } from './Grid';
import { GridBorder } from './GridBorder';
import { StripContent } from './StripContent';
import { StripPosition } from './StripPosition';

export const GridContainer: React.FC = () => {
  const { backgroundRef } = usePlot();

  return (
    // we render into the background <g>
    <Portal to={backgroundRef}>
      {/* we use strip content with the "all" clip type to place it properly and to prevent overflow */}
      <StripContent clipType='all'>
        {/* we use an horizontal window which will let the grid render to the left and the right of the bounds */}
        <StripContent clipType='horizontal'>
          {/* we wrap inside a group which will translate the content based on the current position */}
          <StripPosition contentType='pattern'>
            <Grid />
          </StripPosition>
        </StripContent>
        <GridBorder />
      </StripContent>
    </Portal>
  );
};
